import { saveUserPreferences } from 'utils/helpers';

/** Clears non-event filter preferences — mirrors quarterly event double-click behavior. */
export function clearEventFilterPreferences(): void {
  saveUserPreferences({ genAiFilters: [] });
  saveUserPreferences({ features: [] });
  saveUserPreferences({ products: [] });
  saveUserPreferences({ categories: [] });
  saveUserPreferences({ productGroups: [] });
  saveUserPreferences({ productGroupLabels: [] });
  saveUserPreferences({ audiences: [] });
  saveUserPreferences({ audienceLabels: [] });
  saveUserPreferences({ revenueImpactFilters: [] });
}
